import { z } from 'zod';

export const zodBulkRetryParsingCasesPayloadSchema = z.object({
  caseIds: z.array(z.uuid()).min(1).max(100),
});

const zodBulkRetrySuccessResultSchema = z.object({
  caseId: z.uuid(),
  jobId: z.uuid(),
  status: z.literal('IN_PROGRESS'),
  success: z.literal(true),
});

const zodBulkRetryFailureResultSchema = z.object({
  caseId: z.uuid(),
  errorCode: z.enum([
    'NOT_FOUND',
    'STATE_CONFLICT',
    'ARTIFACT_MISSING',
    'INVALID_REFERENCE',
    'INGESTOR_UPSTREAM',
    'INGESTOR_UNAVAILABLE',
  ]),
  errorDetail: z.string(),
  success: z.literal(false),
});

// fallow-ignore-next-line unused-export
export const zodBulkRetryResultSchema = z.discriminatedUnion('success', [
  zodBulkRetrySuccessResultSchema,
  zodBulkRetryFailureResultSchema,
]);

export const zodBulkRetryParsingCasesResponseSchema = z.object({
  data: z.array(zodBulkRetryResultSchema),
  failed: z.number().int().nonnegative(),
  requested: z.number().int().nonnegative(),
  succeeded: z.number().int().nonnegative(),
});
